import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100svh;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  text-align: center;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #0070f3;
  animation: ${spin} 1s ease-in-out infinite;
  margin: 0 auto;
`;

const LoadingText = styled.p`
  margin-top: 10px;
  color: #666;
  font-size: 14px;
`;

interface LoaderProps {
  text?: string;
}

export const Loader: React.FC<LoaderProps> = ({ text = 'Loading...' }) => {
  return (
    <LoaderContainer>
      <SpinnerWrapper>
        <Spinner />
        <LoadingText>{text}</LoadingText>
      </SpinnerWrapper>
    </LoaderContainer>
  );
};
